import { createAction } from "redux-actions";
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT, LOGIN_FAILURE,CHANGE_PASS, UPDATE_NEXT_DATE_CHANGE_PASSWORD, RESET_STORE, RESPONSE_QUESTIONS, UPDATE_STATUS_MIGRATION_BENEFICIARIES, UPDATE_STATUS_USERNAME_CHANGE} from "../constants";
import { ServerGetDataFeathers, serverLogout, serverLoginFailure, ServerLoginFeathers } from "./../services";
// import { userActions } from "./../api/Auth";
import { urlUsers } from "./../services/urls";



export const loginRequest = createAction(LOGIN_REQUEST, (user) => ServerLoginFeathers(user)())
export const loginSuccess = createAction(LOGIN_SUCCESS, () => ServerGetDataFeathers(urlUsers)())
export const logoutAction = createAction(LOGOUT, () => serverLogout()())
export const resetStore = createAction(RESET_STORE, () =>{})
export const loginFailure = createAction(LOGIN_FAILURE, () => serverLoginFailure()())
export const changeState = createAction(CHANGE_PASS, (state) => state)
export const updateNextDateChangePassword = createAction(UPDATE_NEXT_DATE_CHANGE_PASSWORD, (nextDateChangePassword) => nextDateChangePassword)
export const responseQuestion = createAction(RESPONSE_QUESTIONS, (haveQuestions) => haveQuestions)
export const changeStatusFlagMigrationBeneficiaries = createAction(UPDATE_STATUS_MIGRATION_BENEFICIARIES, (migrateBeneficiaries) => migrateBeneficiaries)
export const changeStatusFlagUsernameChange = createAction(UPDATE_STATUS_USERNAME_CHANGE, (usernameChange) => usernameChange)





/* const loginUser = userObj => ({
    type: 'LOGIN_USER',
    payload: userObj
}) */